import { createSlice } from '@reduxjs/toolkit'
import { Messages } from '@/config/NextImport'
import { decryptData, encryptData } from '@/constants/Common'

/* ---------- helpers ---------- */
const getCookie = (name: string) => {
  if (typeof document === 'undefined') return null
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift()
  return null
}

const applyPriceFromCookie = (products: any[]) => {
  const priceColumn = getCookie('priceColumn') // ex: CA_price
  if (!priceColumn) return products

  const countryCode = priceColumn.split('_')[0]

  const currencyData = JSON.parse(decryptData(localStorage.getItem('currency') || '[]')) || []

  const currency = currencyData.find((c: any) => c.Code === countryCode)

  return products.map((item) => {
    const price = item[priceColumn]
    const filterPrice = item[`${countryCode}_filter_price`]

    return {
      ...item,
      price,
      filter_price: filterPrice,
      formated_price: `${currency?.currency_symbol}${price}`
    }
  })
}

/* ---------- slice ---------- */

const initialState: any = {
  recentViewProducts: []
}

const recentViewProductsSlice = createSlice({
  name: 'recentViewProducts',
  initialState,
  reducers: {
    setRecentViewProductsProducts: (state, action) => {
      state.recentViewProducts = applyPriceFromCookie(action.payload)
    },

    addToRecentViewProducts: (state, action) => {
      try {
        const stored = localStorage.getItem(Messages.last_recent_product)

        const parsedData = stored && stored !== 'null' ? JSON.parse(decryptData(stored)) : []

        // Remove existing product if already viewed (to re-add at latest position)
        const filteredList = parsedData.filter((item: any) => item.sku !== action.payload.sku)

        // Add new product at end (latest viewed)
        const updatedList = [...filteredList, action.payload]

        //  Always keep only latest 8 products
        // const trimmedList = updatedList.slice(-8)

        const finalData = applyPriceFromCookie(updatedList)
        state.recentViewProducts = finalData

        localStorage.setItem(Messages.last_recent_product, encryptData(JSON.stringify(finalData)))
      } catch (error) {
        console.error('Recent View Error:', error)
        state.recentViewProducts = []
        localStorage.removeItem(Messages.last_recent_product)
      }
    },

    /** CALL THIS ON COUNTRY CHANGE */
    updateRecentViewPriceFromCookie: (state) => {
      const updatedData = applyPriceFromCookie(state.recentViewProducts)

      state.recentViewProducts = updatedData

      localStorage.setItem(Messages.last_recent_product, encryptData(JSON.stringify(updatedData)))
    }
  }
})

export const {
  addToRecentViewProducts,
  setRecentViewProductsProducts,
  updateRecentViewPriceFromCookie
} = recentViewProductsSlice.actions

export default recentViewProductsSlice.reducer
